import React from 'react';
import { useHistory } from 'react-router-dom';
import './index.less';
import PageLayout from '../../Components/pageLayout';
import data61 from '../../data/data61.json'
import ArticleList from '../../Components/ArticleList';

const Regulations: React.FC = () => {
    const history = useHistory();

    return (
        <PageLayout history={history} children={[]} Content={
            <div className='page-container'>
                <h1 className='page-title'>规章制度</h1>
                <ArticleList dataId="61" data={data61 as any} />
            </div>
        } />
    );
};

export default Regulations;